/* AMC homepage cart layer (2026-10-29).
   1. The header cart link (a.amc-hdr__cart) opens the cart flyout in place. Modified clicks still follow the link to /cart.
   2. Escape closes the flyout from anywhere on the page, not only while focus is inside it.
   3. A flyout that closes releases the page scroll lock it set.
   4. Product photos below the first screens get loading="lazy" and decoding="async" once, while the browser is idle. */
(() => {
  if (window.__amcHomeCartLayer) return;
  window.__amcHomeCartLayer = true;

  const flyoutElement = () => {
    const el = document.querySelector('cart-drawer');
    return el && typeof el.open === 'function' && typeof el.close === 'function' ? el : null;
  };

  document.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target && event.target.closest ? event.target.closest('a.amc-hdr__cart') : null;
    if (!link) return;
    const drawer = flyoutElement();
    if (!drawer) return;
    event.preventDefault();
    drawer.open(link);
    document.dispatchEvent(new CustomEvent('amc:cart-open', { bubbles: true }));
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const drawer = flyoutElement();
    if (drawer && drawer.classList.contains('active')) drawer.close();
  });

  const watchFlyout = () => {
    const drawer = flyoutElement();
    if (!drawer || drawer.dataset.amcLockWatch === 'true') return;
    drawer.dataset.amcLockWatch = 'true';
    new MutationObserver((records) => {
      const wasOpen = records.some((record) => /\bactive\b/.test(record.oldValue || ''));
      if (wasOpen && !drawer.classList.contains('active')) document.body.classList.remove('overflow-hidden');
    }).observe(drawer, { attributes: true, attributeFilter: ['class'], attributeOldValue: true });
  };

  const lazyBelowFold = () => {
    const viewport = window.innerHeight || 800;
    const scope = document.getElementById('MainContent') || document.body;
    scope.querySelectorAll('img:not([loading])').forEach((img) => {
      if (img.closest('cart-drawer, header')) return;
      const top = img.getBoundingClientRect().top + window.scrollY;
      if (top < viewport * 1.5) return;
      img.loading = 'lazy';
      if (!img.hasAttribute('decoding')) img.decoding = 'async';
    });
  };

  const whenIdle = (task) => ('requestIdleCallback' in window
    ? window.requestIdleCallback(task, { timeout: 1500 })
    : window.setTimeout(task, 300));

  const boot = () => {
    watchFlyout();
    whenIdle(lazyBelowFold);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', watchFlyout);
})();